<div class="container p-0 mt-2">

  <!-- ROW 1: SEARCH BOX & COLLAPSE BUTTON & CHANGE STATUS BUTTON -->
  <div class="row">
    <div class="d-flex justify-content-start align-items-center gap-3">

      <input style="width: 100%; height: 30px;" type="text" [(ngModel)]="searchString" (keyup)="search()" i18n-placeholder
        placeholder="{{'general.search' | translate}}">

      @if (collapse) {
        <button pButton type="text" i18n-pTooltip pTooltip="{{'real-time.filterFleetsModal.expandAll' | translate}}" tooltipPosition="right"
          (click)="expandAll()" icon="fa fa-plus-square"
        style="height:30px; width:30px;text-align:center;vertical-align:middle;  font-size: 13px;"></button>
      } @else {
        <button pButton type="text" i18n-pTooltip pTooltip="{{'real-time.filterFleetsModal.collapseAll' | translate}}" tooltipPosition="right"
          (click)="collapseAll()" icon="fa fa-minus-square"
        style="height:30px; width:30px; text-align:center;vertical-align:middle;  font-size: 13px;"></button>
      }



      @if (visibleChangeStatus && selectableEntities) {
        <div>
          <button pButton type="text" i18n-label label="{{'general.changeStatus' | translate}}" (click)="changeStatus()" icon="fa fa-close"
          style="height:30px; width: 150px; text-align:center;vertical-align:middle;  font-size: 13px;"></button>
        </div>
      }

    </div>
  </div>

  <div class="row mt-2">

    <p-tree [value]="fleetsTree" selectionMode="single" [propagateSelectionUp]="false" [propagateSelectionDown]="false" (onNodeExpand)="nodeExpanded($event, false)">

      <ng-template let-node pTemplate="entity">
        @if (node.data.id > 0) {
          <div class="left">
            <p-checkbox [disabled]="checkBoxDisabled[node.label+'-'+node.data.id]" [id]="node.entityType + node.data.id.toString()" binary="true"
              (onChange)="nodeCheck($event, node)"
            [(ngModel)]="optionEntities[node.label+'-'+node.data.id]" [style]="{'vertical-align':'middle', 'width':'30px'}"></p-checkbox>
          </div>
        }

        @if (selectableEntities) {
          <!-- New -->
          @if (node.data.id < 0) {
            @if (node.entityType === 'Fleet') {
              <span i18n-pTooltip pTooltip="{{'control-panel.vehicles.nonVisibleFleet' | translate}}"
              style="vertical-align:middle;height:21px;text-align:center; font-size: 13px; padding-left:20px;align-items:flex-end;">{{node.label}}</span>
            } @else {
              <span i18n-pTooltip pTooltip="{{'control-panel.vehicles.nonVisibleGroup' | translate}}"
              style="vertical-align:middle;height:21px;text-align:center; font-size: 13px; padding-left:20px;align-items:flex-end;">{{node.label}}</span>
            }
          } @else {
            <button [ngClass]="classButtons[node.label + '-' + node.data.id]" type="submit" (click)="nodeSelect($event,node)"
              style="width: 150px; text-align: left">
              {{node.label}}
            </button>
          }
        } @else {
          <span
          style="vertical-align:middle;height:21px; text-align:left; font-size: 13px; padding-left:10px;align-items:flex-end">{{node.label}}</span>
        }
      </ng-template>

      <ng-template let-node pTemplate="button">
        <button (click)="addButtonClicked(node)" [disabled]="!node._$create || !showAddButtons"
          style="height:21px; text-align:center;vertical-align:middle;  font-size: 13px; margin-bottom: 5px; margin-top: 5px;"
        type="button" pButton icon="fa fa-plus-circle" label={{node.label}}></button>
      </ng-template>

    </p-tree>

    <div class="d-flex justify-content-start">
      <button class="btn custom-button mt-2" (click)="more()" [disabled]="hasMore===false" i18n>{{'general.loadMore' | translate}}</button>
    </div>

  </div>

</div>
